import { useEffect, useState } from 'react';

export const useGroupSpecifications = (product: Product) => {
  const [groupedSpecifications, setGroupedSpecifications] = useState<Record<
    string,
    Specification[]
  > | null>(null);

  useEffect(() => {
    if (!product) return;

    const newGroupedSpecifications = product.specs.reduce(
      (groupedSpecs, specification) => {
        const categoryName = specification.naam;
        if (!groupedSpecs[categoryName]) {
          groupedSpecs[categoryName] = [];
        }
        groupedSpecs[categoryName].push(specification);
        return groupedSpecs;
      },
      {}
    );

    setGroupedSpecifications(newGroupedSpecifications);
  }, [product]);

  return groupedSpecifications;
};
